<script lang="ts" setup>
import { DropdownItem, Icon } from '@brighterly/lib-lumee-ui'

import { getContacts } from '@shared/config'
import { trackEvent } from '@shared/lib/amplitude'

import { useContactLaunchers } from './contact-launchers.hook'

defineOptions({
  name: 'LinkSendSms',
})

const text = 'Send SMS'
const contacts = getContacts()

const {
  openSms,
} = useContactLaunchers()

const setSubmit = (): void => {
  const options = {
    phone: contacts.phone,
    body: 'Support request',
  }

  trackEvent('Link_click', { feature: 'support', name: 'send_sms', text, channel: 'sms' })
  openSms(options)
}

</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    @click="setSubmit"
  >
    <template #leading>
      <Icon
        name="comment"
        size="md"
        color="default"
      />
    </template>
  </DropdownItem>
</template>
